/**
 * User: liliana
 * Date: 8/18/15
 * Time: 11:23 AM
 * Copyright 1stdibs.com, Inc. 2013. All Rights Reserved.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');

var root = require('bunsen/helpers/windowCheck');
var src = "//www.googletagservices.com/tag/js/gpt.js";
var gptLoadedEvent = 'gpt:loaded';
var tryCount = 0;
var retryTimeout;

/**
 * @param {object} options
 * @constructor
 */
function GptLoader(options) {
    options = options || {};
    this.maxTries = options.maxTries || 10;
    this.retryDelay = options.retryDelay || 250;
}

_.extend(GptLoader.prototype, {

    /**
     * Load GPT script
     * @returns {$.Deferred}
     */
    load() {
        // getScript should only get called once to prevent multiple GPT scripts on page
        if (!GptLoader.loadedOnce) {
            GptLoader.loadedOnce = true;
            $.when($.getScript(src)).done(() => {
                this.ensureGoogletagIsLoaded();
            });
        }
        return GptLoader.gptLoaded;
    },

    /**
     * Ensure googletag reference gets populated rather than only running once after the GPT script had been loaded
     * The DFP/GPT Api has changed so this should probably be revisited
     */
    ensureGoogletagIsLoaded() {
        if (!GptLoader.googletag && root.googletag) {
            GptLoader.googletag = root.googletag;
        }

        if (GptLoader.googletag && GptLoader.googletag.apiReady) {
            clearTimeout(retryTimeout);

            $.publish(gptLoadedEvent);
            GptLoader.gptLoaded.resolve();

        } else {
            // If googletag has not been loaded, retry check
            this.setRetryTimeout();
        }
    },

    /**
     * Set timeout to recheck whether googletag has loaded after delay
     */
    setRetryTimeout() {
        if (tryCount < this.maxTries) {
            retryTimeout = setTimeout(() => {
                this.ensureGoogletagIsLoaded();
            }, this.retryDelay);
        }
        tryCount++;
    }
});

_.extend(GptLoader, {
    /**
     * @param {object}
     * @static
     */
    googletag : null,
    /**
     * @param {boolean}
     * @static
     */
    loadedOnce : false,
    /**
     * @param {$.Deferred}
     * @static
     */
    gptLoaded : $.Deferred() // eslint-disable-line
});

module.exports = GptLoader;



// WEBPACK FOOTER //
// ./assets/js/global/modules/GptLoader.es.js